import {
  defaultBooleanFilter,
  defaultDateFilter,
  defaultRelationFilter,
  defaultStringFilter,
  type Filter,
} from '@/components/table-filters/constants';

import { Icons } from '@/components/icons';
import { ParkingSpotVacancyNotationConfig } from '@pigello/pigello-matrix';
import baseFilters, {
  baseGlobalRealEstatesFilter,
  baseTagFilter,
} from '../../filters';
import { defaultVacancyContractStatusFilter } from '../base-status-enum-filter';

const parkingSpotVacancyContractFilter: Filter[] = [
  ...defaultVacancyContractStatusFilter,
  {
    ...defaultStringFilter,
    title: 'Avtals-ID',
    externalFieldName: 'custom_id',
  },
  {
    ...defaultRelationFilter,
    title: ParkingSpotVacancyNotationConfig.fields.space.verboseName,
    relationModelName: ParkingSpotVacancyNotationConfig.modelName,
    externalFieldName:
      ParkingSpotVacancyNotationConfig.fields.space.externalFieldName,
    icon: Icons.parkingspot,
  },
  {
    ...defaultBooleanFilter,
    title: ParkingSpotVacancyNotationConfig.fields.automatic.verboseName,
    externalFieldName: 'automatic',
  },
  {
    ...defaultBooleanFilter,
    title: ParkingSpotVacancyNotationConfig.fields.annulled.verboseName,
    externalFieldName: 'annulled',
  },
  {
    ...defaultDateFilter,
    title: ParkingSpotVacancyNotationConfig.fields.startDate.verboseName,
    externalFieldName: 'start_date',
  },
  {
    ...defaultDateFilter,
    title: ParkingSpotVacancyNotationConfig.fields.endDate.verboseName,
    externalFieldName: 'end_date',
  },
  ...baseGlobalRealEstatesFilter,
  ...baseTagFilter,
  ...baseFilters,
];

export default parkingSpotVacancyContractFilter;
